export default {
  heading: {
    subtitle: "Problème de chasse d'eau WC",
    icons: [
      {
        src: "/img/icons/approve-invoic-bicolor-light.png",
        alt: "Icone devis",
      },
      {
        src: "/img/icons/calendar-bicolor-light.png",
        alt: "Icone calendrier",
      },
      {
        src: "/img/icons/piggy-bank-bicolor-light.png",
        alt: "Icone tarifs",
      },
    ],
    items: [
      " Intervention dans la semaine",
      " Toutes marques de WC standards",
      " 125 € pour un remplacement",
    ],
  },
  section1: {
    title: "Une intervention rapide et efficace :",
    text: `Votre chasse d'eau ne se remplit plus ou lentement ? Vous n'arrivez pas à tirer la chasse ? 
    Vous constatez que le mécanisme est cassé ? 
    <br/><br />Le calcaire et l'utilisation quotidienne de vos toilettes peuvent 
    entraîner des détériorations de votre matériel. 
    <br /><br />La source du problème peut varier d'un cas à l'autre : mécanisme, robinet flotteur, joint, etc, 
    et est la plupart du temps réparable en moins d'une heure.`,
    ctaText: "Pour planifier un rendez-vous, appelez nous au :",
  },
  section2: {
    title: "",
    subtitle1: "",
    steps1: [],
    text1:
      "Le problème peut provenir de l’ensemble de la chasse d’eau ou de son mécanisme. Notre plombier se chargera de vérifier l'ensemble du mécanisme, ainsi que le robinet flotteur, le flotteur, les joints et le remplisseur d'eau, qui peuvent tous être source du problème.",
    subtitle2: "",
    text2:
      "En fonction de la partie défectueuse, l'intervention peut aller d'une simple manipulation au remplacement de la pièce en question. Elle peut durer entre 30 minutes et 2 heures.",
    subtitle3: "",
    text3:
      "Notre forfait de réparation de chasse d'eau vous est proposé au prix de 125 € TTC. Il comprend la main d'oeuvre, le matériel nécessaire à l'intervention et le déplacement.",
    steps3: [],
    lastText: "",
    ctaText: "Planifiez votre RDV dans la semaine ! <br />",
    ctaTextMobile:
      'Appelez-nous et planifiez <br />votre RDV dans <span class="no-wrap"> la semaine !</span>',
  },
  aside: {
    ctaText:
      "La chasse d'eau de vos WC ne fonctionne pas correctement ? Appelez-nous : ",
    img: {
      src: "/img/pages/page-content_team.jpg",

      alt: "Equipe de plombiers qualifiés",
    },
    quoteRequest: {
      recipient: "contact+devisChasse",
      body:
        "Bonjour,%0D%0A %0D%0A voici ma demande de devis :%0D%0A - Description : %0D%0A - Délai : %0D%0A - Code postal : %0D%0A - Ville : %0D%0A - Nom : %0D%0A - Numéro de téléphone (optionnel) : %0D%0A %0D%0A Bien à vous",
    },
  },
};
